import * as CookieConsent from "vanilla-cookieconsent";


const initCookies = () => {
    CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: "box wide",
                position: "bottom left",
                equalWeightButtons: true,
                flipButtons: true
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                equalWeightButtons: true,
                flipButtons: true
            }
        },
        categories: {
            necessary: {
                readOnly: true
            },
            functionality: {},
            analytics: {},
            marketing: {}
        },
        language: {
            default: "fr",
            translations: {
                fr: {
                    consentModal: {
                        title: "Gestion des Cookies",
                        description: "Nous utilisons les cookies pour personnaliser votre expérience. En continuant de visiter notre site, vous acceptez notre politique de confidentialité.",
                        closeIconLabel: "",
                        acceptAllBtn: "Accepter",
                        acceptNecessaryBtn: "Rejeter",
                        showPreferencesBtn: "Préférences",
                        footer: ""
                    },
                    preferencesModal: {
                        title: "Préférences de cookies",
                        closeIconLabel: "Fermer",
                        acceptAllBtn: "Tout accepter",
                        acceptNecessaryBtn: "Rejeter",
                        savePreferencesBtn: "Sauvegarder les préférences",
                        serviceCounterLabel: "Services",
                        sections: [
                            {
                                title: "Utilisation des Cookies",
                                description: "Pour vous offrir la meilleure expérience, nous utilisons des technologies comme les cookies pour stocker et/ou accéder aux informations relatives à votre appareil. En consentant, vous nous permettez de traiter des données telles que votre navigation ou des identifiants uniques sur ce site. Ne pas consentir ou retirer votre consentement peut affecter certaines fonctionnalités."
                            },
                            {
                                title: "Fonctionnel <span class=\"pm__badge\">Toujours Activé</span>",
                                description: "Cet accès est strictement nécessaire dans le but légitime de permettre l'utilisation d'un service spécifique explicitement demandé par l'abonné ou l'utilisateur, ou dans le seul but d'effectuer la transmission d'une communication sur un réseau de communications électroniques.",
                                linkedCategory: "necessary"
                            },
                            {
                                title: "Marketing",
                                description: "Nécessaire pour créer des profils d'utilisateurs afin d'envoyer de la publicité, ou pour suivre l'utilisateur sur un site web ou sur plusieurs sites web à des fins de marketing similaires.",
                                linkedCategory: "marketing"
                            },
                            {
                                title: "Statistiques",
                                description: "Utilisé exclusivement à des fins statistiques anonymes. En l'absence d'une assignation à comparaître, d'une coopération volontaire de la part de votre fournisseur d'accès à Internet ou de données supplémentaires provenant d'un tiers, les informations stockées ou récupérées à cette seule fin ne peuvent généralement pas être utilisées pour vous identifier.",
                                linkedCategory: "analytics"
                            }
                        ]
                    }
                }
            }
        },

        onModalShow: () => {
            document.querySelectorAll('#cc-main .pm__section--toggle').forEach((el) => {
                el.classList.add('is-expanded')
            })

            __setPrefLabel();
            const prefBody = document.querySelector('#cc-main .pm__body')
            if (prefBody) prefBody.classList.add('custom__scrollbar')
        }
    }).then(x => x);


    const __setPrefLabel = () => {
        const prefNode = document.querySelector('#cc-main .cm__btns .cm__btn-group [data-role=show]');
        if (prefNode) {
            const span = prefNode.querySelector('span')
            const text: string = window.innerWidth <= 576 ? 'Modifier les préférences de cookies' : 'Préférences';
            if (span) span.textContent = text;
            else prefNode.textContent = text;
        }
    }

    window.addEventListener('resize', () => __setPrefLabel())
}

export const Cookies = {
    consent: {
        init: initCookies
    }
}

export default Cookies;